import type { useTranslation } from "react-i18next";

import { HttpError, HTTP_FORBIDDEN, HTTP_UNPROCESSABLE_ENTITY } from "./api";

// Человекочитаемый текст серверной ошибки мутации настроек организации:
// 422 → `detail` валидатора (или fallback), 403 → «недостаточно прав»,
// любой другой код / не-HttpError → generic-ключ.
export function serverErrorText(
  error: Error,
  t: ReturnType<typeof useTranslation>["t"],
): string {
  if (error instanceof HttpError) {
    if (error.status === HTTP_UNPROCESSABLE_ENTITY) {
      return error.detail ?? t("settings.serverError.invalid");
    }
    if (error.status === HTTP_FORBIDDEN) {
      return t("settings.serverError.forbidden");
    }
  }
  return t("settings.serverError.generic");
}
